// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__v5xw3","description":"default_description__qPJao","control":"default_control__yVy2S","link":"default_link__L65bt"};